import { z } from "zod";
import { ThreadSort } from "@/gql/graphql";

const validThreadSorts = Object.values(ThreadSort);

/**
 * Shared by every route holding a thread list panel, so the sort survives a
 * reload and travels with a shared link.
 */
export const threadSearchParams = z.object({
  threadSort: z
    .string()
    .optional()
    .transform((sort) =>
      validThreadSorts.includes(sort as ThreadSort)
        ? (sort as ThreadSort)
        : undefined,
    ),
});
